import { atom } from 'recoil';


export const upcRacesAtom = atom<any>({
    key:"upcRacesAtom",
    default:{},
})